import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-soft font-medium uppercase tracking-wider transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 shadow-pastel-sm hover:shadow-pastel-md transform hover:-translate-y-0.5',
  {
    variants: {
      variant: {
        default: 'bg-primary text-white hover:bg-primary/90',
        secondary: 'bg-secondary text-dark hover:bg-secondary-light',
        outline:
          'border border-primary/70 text-primary hover:bg-primary/5 hover:border-primary',
        ghost: 'text-primary hover:bg-primary/5',
        link: 'text-primary underline-offset-4 hover:underline hover:text-secondary shadow-none hover:shadow-none transform-none',
        pastel: 'bg-blush text-text-dark hover:bg-blush/90',
        'pastel-blue': 'bg-sky text-text-dark hover:bg-sky/90',
        'pastel-green': 'bg-mint text-text-dark hover:bg-mint/90',
        'pastel-purple': 'bg-lavender text-text-dark hover:bg-lavender/90',
      },
      size: {
        default: 'h-12 px-8 py-3',
        sm: 'h-9 px-4 py-2 text-xs',
        lg: 'h-14 px-10 py-4 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button, buttonVariants };
